import { createMakeAndWithStyles } from "tss-react";
import { useTheme } from "@mui/material/styles";

// Create tss-react makeStyles that is backward compatible with @mui/styles
const { makeStyles: tssReactMakeStyles } = createMakeAndWithStyles({ useTheme });

// Wrapper to maintain backward compatibility with @mui/styles API
// @mui/styles: const useStyles = makeStyles(...); const classes = useStyles();
// tss-react: const useStyles = makeStyles()(...); const { classes } = useStyles();
/* eslint-disable @typescript-eslint/no-explicit-any -- tss-react compatibility shim requires any */
export const makeStyles = (
  stylesOrCreator: Record<string, any> | ((...args: any[]) => Record<string, any>)
): (() => Record<string, string>) => {
  /* eslint-enable @typescript-eslint/no-explicit-any */
  const useTssStyles = tssReactMakeStyles()(stylesOrCreator);

  // Return a hook that returns classes directly (not { classes })
  return (): Record<string, string> => {
    const { classes } = useTssStyles();
    return classes;
  };
};
